export const DyLangAr = {


    dashbordDy: {
        smsStats:'sms stats',
        totalsendnum:'Total amount sent',
        selfsendnum:'Myself send',
        contactsendnum:'Contacts sent',
    nochoosed:'Not selected', 
    firstLoan:'first Loan',
    CompoundLoan:'Reloan',
    CardIssuanceFeeReduction:"Card issuance fee reduction",
    IsCardIssuanceFeeReduction: "Whether to reduce or exempt the card opening fee?",
    open:'Open',
    isOpen:'Do you want to open order?',
    notickets:'You have no pending tickets, please remind the manager to divide the tickets',
    passAutomatically:'Whether to pass automatically',
    yes:"Yes",
    no:'NO',
    Repayment:'RepaymentChannel',
    RelatedInformation:'Related Information',
    auditFailed:'Audit failed',
    examinationPassed:"examination Passed",
    Unreviewed:'Unreviewed',
    NextCallTime:"Next call time",
    unassign:'Are you sure to unassign?',
    source:"source",
    GenerateTicket:"Generate ticket",
    DialTheRecordingID:'Dial the recording ID',
    Collector:'Collector',
        QualityInspector:"Quality Inspector",
        assigntime:'Work order allocation time',
        startime:'Star Time',
        completetime:'Complete Time',
        normal:'normal',
        AbusiveCustomer:'Abusive customer',
        sop:'Does not meet sop',
        CustomerPromises:"Customer promises are inconsistent with reminders",
        CollectionInformation:'Collection information',
        QualityInspectionInformation:'Quality inspection information',
        Aging:"Aging",
        DialTime:'Dial time',
        HangUpReason:'Hang up reason',
        recording:'recording',
        RecordingType:'Recording type',
        processResult:'process result',
        queryConditions:'Please fill in at least one query information',
        characters:'The label cannot exceed 80 characters',
        ticketID:'Quality Inspection Work Order ID',
        RepaymentCode:'Repayment code',
        RepaymentCodeChannel:'Repayment code channel',
        selectRepaymentCodeChannel:'Please select the repayment code channel first',
        Date:'Date',
        Totalorders:'Loan Number',
        NoWhatAppsnumber:'Without WhatsApp',
        HandleNumber:'Handle Number',
        HandleNumberpercent:'Percentage of reminders',
        TotalUnconnected:"Total Unconnected",	
        Busy:"Busy",
        Reject:	"Reject",
        CaseLevel:'Case Level',
        NotActive:	"Not Active",
        CustomerBlocked	:"Customer Blocked"	,
        ContinueRinging:"Continue Ringing",	
        OutofCoverage:"Out of Coverage",	
        NotRegisterd:"Not Registerd",
        TotalConnected:	"Total Connected	",
        NoMoney:	"No Money"	,
        LeftMessagetoCP:'Left Message to CP',
        WTP:'Willing to Pay',
        PartialPayment:	'Partial Payment',
        Rolling	:'Rolling',
        BP:	"Broken Promise",
        Underestimate:	'Underestimate',
        DelayPayment:'Delay Payment'	,
        DataInvalid:'Data Invalid'	,	
        NotCustomer:'Not Customer',
        DidReceiveMoney:'Customer Didnt Receive Money',
        Unconnected	:'Unconnected',
        Connected:'Connected',
        Pleaseentervaliddays:'Please enter valid days',
        SampleID:"Sample ID",
        principal:'principal',
        OCRstatus:"OCRstatus",
        OCRrecognitiontime:'OCR recognition time',
        Assignworkorder:'Assign work order',
        processed:"processed",
        Recognitionfailed:"Recognition failed",
        logicalerror:"logical error",
        backfillcorrection:"backfill correction",
        processingCompleted:'processing completed',
        confirmed:'confirmed',
        SampleAnomaly:"Sample anomaly",
        nexttikct:"next",
        Currentlythelastorder:'Currently the last order',
        handle:"handle",
        UnmarkedContent:"Unmarked Content",
        recordingDuration:"recording Duration",
        MachineQuality:"Machine quality inspection status",
        QualityEnspection:"Quality inspection work order status",
        CollectionVoice:'Collection Voice',
        salesman:"salesman",
        user:"user",
        FinalQualityinspectionscore:"Final Quality Inspection Score",
        AIQualityInspectionScore:"AI Quality Inspection Score",
        ManualQualityInspectionScore:"Manual Quality Inspection Score",
        triggerFragment:"trigger Fragment",
        triggerRule:'trigger Rule',
        ruleId:'rule Id',
        QualityInspectionType:'Quality Inspection Type',
        keywordsPhrases:"words/sentences",
        Score:"Score",
        AIQualityInspectionConfiguration:"AI Quality Inspection Configuration",
        keywordLibrary:'keywordLibrary',
        QualityInspectionRules:'Quality Inspection Rules',
        QCtext:'QC text',
        QualityInspectionTemplate:'Quality Inspection Template',
        newTalkPoint:"new talk point",
        founder:'founder',
        TalkPointName:"Word library name",
        NumberOfSpeakingPoints:'Number  Of Speaking Points',
        Talkingpointlibrary:'Talking point library',
        RuleID:"Rule ID",
        ruleName:"rule name",
        AddPoints:'Extra points',				
        MinusPoints:'deduct points',				
        Scoring:"Scoring",
        score:'score',
        TheNumberOfQualityInspectionPoints:'Jumlah titik pemeriksaan kualitas',
        BasicInformation:"Basic Information",
        RulesDescription:'Rules Description',
        numberofmatches:'number of matches',
        QualityInspectionPoints:"Quality Inspection Points",
        QCPointType:"QC Point Type",
        QCobject:'QC object',
        SpellPointHitRules:"Spell Point Hit Rules",
        Within:"Within",
        consecutiveReplies:"consecutive replies",
        Repeat :'Repeat',
        times:'times',
        AddQCpoint:'Add QC point',
        Thelogical:'The logical relationship between the quality inspection points',
        or:'or',
        and:'and',
        templateName:'template Name',
        enabledstate:'enabled state',
        Scopeofapplication:'Scope of application',
        Containstherulebook:'Contains the number of rules',
        Inclusionrules:'Inclusion rules',
        currentstate:'currentstate',
        Disable:'Disable',
        addNewRules:'New rule',
        TemplateDescription:'Template Description',
        Applicableaccountperiod:'Applica bleac countperiod',
        Qualityinspectionscoringitems:'Quality inspection scoring items',
        artificial:'artificial',
        abandoned:'abandoned',
        Obsolete:'Obsolete',
        Copywriting:'Copywriting',
        Qualityinspectionlabel:'Quality inspection label',
        correctcopywriting:'correct copywriting',
        speechrecognitioncopywriting:'speech recognition copywriting',
        voiceclip:'voicec lip',
        return:'return',
        fix:"fix",
        Nocorrectionrequired:'No correction required',

        AIqualityinspectionstatus:'AI quality inspection status',
        Manualqualityinspectionscore:'Manual quality inspection score',
        AIqualityinspectionscore:'AI quality inspection score',
        WaktupemeriksaankualitasAI:'AI quality inspection time',
        Qualityinspected:'Quality inspected',
        Notinspected:'Not inspected',
        unlimited:"unlimited",
        activated:"In use",			
        terminated:"terminated",
        finalscore:"nilai akhir",
        scoreisrepeated:'The quality inspection score is repeated, please verify and resubmit',
        created:"created",
        Addaratingitem:'Add arating item',
        previouspage:'The content you edited has not been saved and submitted. Are you sure to abandon the editing and return to the previous page?',
        continueediting:'continue editing',
        confirmreturn:'confirm return',
        UpdateAIscore:"Update AI score",
        SpeechRecognitionCopywritinga:'Speech Recognition Copywriting',
        resultsafterwhile:'The AI score has been updated, please check the results after a while',
        Enterkeywordstofilter:'Enter keywords to filter',

        totalorder:"total order",
        Rolloverorder:'Rollover order',
        Suborder:'Sub-order',
        inputMessage: 'input message',
        notWAUser: 'The other side is not a WhatsApp user',
        notLoginWA: 'The current account is not logged in to WhatsApp',
        alreadyLoginWA: 'You have signed in to WhatsApp',
        pleaseSelectChat: 'Please select a chat',
        emptyMessage: 'Chat message cannot be empty',
        noTemplateMessage: 'Custom messages are not supported',

        AppName:'app name',
        selectAppName:'Please select the project',
        subItem: 'Whether to divide the project',
}
};